<template>
    <v-card>
        <v-card-title class="dialog-header">
            <span class="headline" v-if="toggleAdd">{{ $t("productTakeOut") }}</span>
            <span class="headline" v-if="!toggleAdd">{{ $t("editProductTakeOut") }}</span>
            <v-spacer></v-spacer>
            <v-btn
                fab
                text
                icon
                @click="handleClose"
                valid="false"
                v-shortkey="['esc']"
                @shortkey.native="handleClose"
            >
                <v-icon dark>
                    mdi-close
                </v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text>
            <v-form v-model="valid" ref="formData">
                <v-overlay :value="overlay"><v-progress-circular indeterminate size="64"></v-progress-circular></v-overlay>
                <v-row>
                    <v-col cols="12" sm="3" md="3" class="seperate-line-verticle">
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-text-field
                                    dense
                                    outlined
                                    disabled
                                    v-model="formDoc.client_name"
                                    :label="$t('client')"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="12" v-if="userDoc.type === 'employee'">
                                <v-text-field
                                    dense
                                    disabled
                                    outlined
                                    v-model="formDoc.supplier_name"
                                    :label="$t('supplier')"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <v-select
                                    :items="currencyOptionList"
                                    :label="$t('currency')"
                                    outlined
                                    v-model="formDoc.currency_code"
                                    disabled
                                    item-text="text"
                                    item-value="id"
                                    dense
                                ></v-select>
                            </v-col>
                            
                            <v-col cols="12" sm="12" md="12">
                                <v-menu
                                    v-model="menuDate"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            outlined
                                            dense
                                            v-model="formDoc.date"
                                            :label="$t('takeOutDate')"
                                            prepend-inner-icon="mdi-calendar"
                                            readonly
                                            :rules="dateRules"
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        :first-day-of-week="0"
                                        v-model="formDoc.date"
                                        :rules="dateRules"
                                        @input="menuDate = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <v-text-field
                                    outlined
                                    dense
                                    v-model="formDoc.reference"
                                    :label="$t('reference')"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-col cols="12" sm="9" md="9">
                        <v-row>
                            <v-col cols="12" md="12" sm="12">
                                <v-data-table
                                    :headers="transaction_line_header"
                                    :items="transaction_line"
                                    hide-default-footer
                                    mobile-breakpoint="0"
                                >
                                    <template v-slot:header.name="{ header }">{{ $t(header.text) }}</template>
                                    <template v-slot:header.order_qty="{ header }">{{ $t(header.text) }}</template>
                                    <template v-slot:header.qty="{ header }">{{ $t(header.text) }}</template>
                                    <template v-slot:header.price="{ header }">{{ $t(header.text) }}</template>
                                    <template v-slot:header.sub_total="{ header }">{{ $t(header.text) }}</template>
                                    <template v-slot:header.action="{  }">
                                        <!-- <v-checkbox
                                            v-model="checkAll" @change="toggleCheckAll"
                                            color="success"
                                            hide-details
                                        ></v-checkbox> -->
                                    </template>
                                    <template v-slot:item.qty="{ item }">
                                        <v-text-field
                                                style="min-width: 150px"
                                                type="number"
                                                v-model="item.qty"
                                                @input.native="updateProductTakeOutLine(item)"
                                                hide-details="auto"
                                                :max="item.order_qty"
                                                min="0"
                                                :suffix="item.unit_name"
                                                dense
                                        ></v-text-field>
                                    </template>
                                    <template v-slot:item.price="{ item }">{{ item.price | formatNumber }}</template>
                                    <template v-slot:item.sub_total="{ item }">{{ item.sub_total | formatNumber }}</template>
                                    <template v-slot:item.action="{ item }">
                                        <v-checkbox
                                            v-model="item.isCheck"
                                            @change="toggleProductTakeOutLine(item)"
                                            hide-details
                                        ></v-checkbox>
                                    </template>
                                </v-data-table>
                            </v-col>

                            <v-col sm="8" cols="2" style="text-align: right;"
                            ><h3>{{ $t("totalAmount") }} :</h3></v-col
                            >
                            <v-col
                                cols="10"
                                sm="4"
                                style="font-weight: bold;font-size: 25px"
                            >
                                {{ formDoc.total_amount | formatNumber }}
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <v-textarea
                                    clearable
                                    outlined
                                    :placeholder="$t('yourDesc')"
                                    v-model="formDoc.note"
                                    clear-icon="mdi-close-circle"
                                    rows="3"
                                    auto-grow
                                    :label="$t('note')"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="reset">{{$t('reset')}}</v-btn>

            <!-- <v-btn rounded @click="submit($event,true)" style="min-width: 150px" color="primary">
                <font-awesome-icon icon="check-circle" class="mr-2"/>
                {{$t('saveAndPay')}}
            </v-btn> -->

            <v-btn rounded @click="submit($event,false,true)" style="min-width: 150px" color="warning">
                <font-awesome-icon icon="check-circle" class="mr-2"/>
                {{$t('saveAndPrint')}}
            </v-btn>

            <v-btn rounded @click="submit($event)" style="min-width: 150px" color="success">
                <font-awesome-icon icon="check-circle" class="mr-2"/>
                {{$t('save')}}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>

    import OptionDataMixin from "../../../mixins/optionDataMixin";
    import MainMixin from "../../../mixins/mainMixin";
    import ValidatorMixin from "../../../mixins/validatorMixin";

    import moment from "moment";
    import {provider} from "@/service/provider";
    import axios from "axios";

    export default {
        mixins: [OptionDataMixin, MainMixin, ValidatorMixin],
        components: {},
        props: ["productOrderDoc", "isEdit"],
        name: "ProductTakeOut",
        data() {
            return {
                checkAll: false,
                dialogDetail: false,
                detailDoc: {},
                page: 1,
                formDoc: {
                    id: "",
                    transaction_order_id: "",
                    business_id: "",
                    supplier_id: "",
                    supplier_mobile: "",
                    client_id: "",
                    client_phone: "",
                    time: "",
                    date: moment().format("YYYY-MM-DD"),
                    type: "",
                    reference: "",
                    total_amount: 0,
                    paid_amount: 0,
                    balance: 0,
                    currency_code: "",
                    note: "",
                    supplier_name: "",

                    product_type: "",
                    user_id: "",
                    payment_method: "cash",
                    duration: 0,
                    duration_period: "per_month",
                    interest_rate: 0,
                    total_interest: 0

                },
                transaction_line: [],
                transaction_line_header: [
                    {
                        text: "productName",
                        align: "start",
                        sortable: false,
                        value: "name"
                    },
                    {text: "price", value: "price", sortable: false},
                    {text: "orderQty", value: "order_qty", width: 150, sortable: false},
                    {text: "takeOutQty", value: "qty", width: 150, sortable: false},
                    {text: "amount", value: "sub_total", sortable: false},
                    {text: "action", value: "action", sortable: false, width: 50}
                ],
                balance: 0,
                available_balance: 0,
            };
        },
        methods: {
            handleProductTakeOut(doc) {
                let vm = this;
                if (this.isEdit === false) {
                    vm.toggleAdd = true;
                    vm.formDoc = doc;
                    vm.formDoc.date = moment().format("YYYY-MM-DD");
                    vm.formDoc.id = "";
                    vm.formDoc.reference = "";
                    vm.formDoc.payment_method = "cash";
                    vm.transaction_line = [];
                    doc.transaction_order_line.forEach((d) => {
                        d.currency_code = vm.formDoc.currency_code;
                        d.currency_symbol = vm.getCurrencySymbol(vm.formDoc.currency_code);
                        d.order_qty = parseFloat(d.order_qty) - parseFloat(d.accepted_qty || 0);
                        d.qty = 0;
                        d.price = parseFloat(d.price);
                        d.sub_total = 0;
                        d.transaction_line_id = "";
                        vm.transaction_line.push(d);
                    })
                } else {
                    vm.toggleAdd = false;
                    vm.formDoc = doc;
                    vm.formDoc.date = moment().format("YYYY-MM-DD");
                    vm.transaction_line = [];
                    vm.formDoc.payment_method = "cash";
                    vm.transaction_line.push(...doc.transaction_line);
                    vm.transaction_line.map((d) => {
                        d.currency_code = vm.formDoc.currency_code;
                        d.currency_symbol = vm.getCurrencySymbol(vm.formDoc.currency_code);
                        d.order_qty = parseFloat(d.order_qty);
                        d.qty = parseFloat(d.qty);
                        d.price = parseFloat(d.price);
                        d.sub_total = d.price * d.qty;
                        d.transaction_line_id = d.transaction_line_id || "";
                        return d;
                    })
                }
                vm.$nextTick(() => {
                    vm.calculateTotal();
                });
            },
            handleClose(e, payDoc) {
                let vm = this;
                vm.$emit("handleCloseProductTakeOutForm", payDoc);
                this.reset();
            },
            submit(event, isPayment,isPrint) {
                let vm = this;
                event.preventDefault();
                if (vm.$refs.formData.validate()) {

                    /** Check each item line */
                   if(vm.transaction_line.filter(obj => { return obj.qty > 0 }).length){

                        vm.overlay = true;
                        vm.formDoc.user_id = localStorage.id;
                        vm.transaction_line.map((d) => {
                            d.qty = parseFloat(d.qty);
                            d.price = parseFloat(d.price);
                            d.sub_total = parseFloat(d.sub_total);
                            return d;
                        })
                        vm.formDoc.note = vm.formDoc.note || "";
                        vm.formDoc.transaction_line = vm.transaction_line;
                        let newFormDoc = Object.assign({}, vm.formDoc);
                        newFormDoc.date = vm.parseToDate(vm.formDoc.date);
                        newFormDoc.driver_phone = "+855" + newFormDoc.driver_phone;
                        newFormDoc.paid_amount = 0;
                        let url = provider.baseURL + provider.storeTransactionProductTakeOut;
                        return new Promise((resolve, reject) => {
                            axios.post(url, newFormDoc, {headers: {Authorization: localStorage.token}}).then(
                                res => {
                                    if (res.data.response && res.data.response.code === 200) {
                                        resolve(res.data.data.transaction_take_out);
                                        vm.$notify({
                                            title: "Success",
                                            message: vm.$t("success"),
                                            type: "success",
                                            duration: 700
                                        });
                                        vm.dialog = false;
                                        if (isPayment) {
                                            let payDoc = {};
                                            payDoc.isPayment = isPayment;
                                            payDoc.transaction_take_out = res.data.data.transaction_take_out;
                                            vm.handleClose("", payDoc);
                                        }else if(isPrint===true){
                                            vm.$router.push({name: 'beeshop.agri-input.order-farmer-management.print-invoice-farmer', params: { id: res.data.data.transaction_take_out, back: 'beeshop.agri-input.order-farmer-management.order-list'}})
                                        }else{
                                            vm.handleClose("", {});
                                        }
                                    }else if(res.data.response && res.data.response.code===300){
                                        vm.$notify({
                                            title: "Error",
                                            message: res.data.response.message,
                                            type: "error",
                                            duration: 1200
                                        });
                                    }
                                    vm.overlay = false;

                                },
                                error => {
                                    reject(error);
                                    vm.overlay = false;

                                }
                            );
                        });

                    }
                    else {
                        vm.$notify({
                            title: "Error",
                            message: vm.$t("pleaseCheckProductDelivery"),
                            type: "error",
                            duration: 2000
                        });
                   }
                }
            },
            updateProductTakeOutLine(row) {
                let vm = this;
                let newDoc = row;
                let index = vm.transaction_line.findIndex(
                    ind => ind.product_id === row.product_id
                );

                let qty = 0;
                if(vm.allowQuantity(newDoc)){
                    qty = +newDoc.qty;       
                }
                else{
                    vm.$notify({
                        title: "Error",
                        message: vm.$t("stockOnHandMessage"),
                        type: "error",
                        duration: 1500
                    });
                }

                newDoc.qty = qty;
                newDoc.sub_total = parseFloat(qty) * parseFloat(newDoc.price);
                vm.transaction_line[index] = newDoc;
                let tmp = vm.transaction_line;
                vm.transaction_line = [];
        
                vm.$nextTick(() => {
                    vm.transaction_line = tmp;    
                    vm.calculateTotal();
                });
            },

            toggleProductTakeOutLine(row) {
                let vm = this;
                let qty = 0;
                if (row.isCheck) {
                    let newDoc = row;
                    let index = vm.transaction_line.findIndex(
                        ind => ind.product_id === row.product_id
                    );

                    if(+newDoc.order_qty <= +newDoc.qty_on_hand){
                        qty = +newDoc.order_qty;       
                    }
                    else{
                        vm.$notify({
                            title: "Error",
                            message: vm.$t("stockOnHandMessage"),
                            type: "error",
                            duration: 1500
                        });
                    }

                    newDoc.qty = qty;
                    newDoc.sub_total = parseFloat(newDoc.qty) * parseFloat(newDoc.price);
                    vm.transaction_line[index] = newDoc;

                    let unCheckDoc = vm.transaction_line.find(o => o.isCheck === false);
                    if (!unCheckDoc) {
                        vm.checkAll = true;
                    }

                    let tmp = vm.transaction_line;
                    vm.transaction_line = [];
                    vm.$nextTick(() => {
                        vm.transaction_line = tmp;    
                        vm.calculateTotal();
                    });

                } else {
                    let newDoc = row;
                    let index = vm.transaction_line.findIndex(
                        ind => ind.product_id === row.product_id
                    );
                    newDoc.qty = qty;
                    newDoc.sub_total = parseFloat(newDoc.qty) * parseFloat(newDoc.price);

                    vm.transaction_line[index] = newDoc;
                    vm.checkAll = false;

                    vm.$nextTick(() => {
                        vm.calculateTotal();
                    });
                }
                
            },
            calculateTotal() {
                let vm = this;
                vm.formDoc.total_amount = 0;
                if (vm.transaction_line && vm.transaction_line.length > 0) {
                    vm.transaction_line.forEach((obj) => {
                        vm.formDoc.total_amount += parseFloat(obj.sub_total);
                    })
                }
            },
            toggleCheckAll(val) {
                let vm = this;
                vm.transaction_line.forEach((obj) => {
                    obj.isCheck = val;
                    vm.toggleProductTakeOutLine(obj);
                })
            },

            /** return @bool */
            allowQuantity(obj){
                if(Object.keys(obj).length){
                    if(+obj.qty <= +obj.order_qty){
                        return +obj.qty_on_hand >= +obj.qty;
                    }
                }
                return false;
            },
        
        },
        watch: {},
        computed: {
            userDoc() {
                return this.$store.state.userDoc;
            }
        },
        created() {
            let vm = this;
            vm.handleProductTakeOut(this.productOrderDoc);
            vm.fetchCurrencyOption();
            vm.formDoc.duration_period = "per_month";
        }
    };
</script>
